import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';

// constants
import { Spinner } from '@tcc/crate';
import { scriptTypes } from 'constants/scripts';

import FlipMove from 'react-flip-move';
import ApplicationScriptCardContainer from 'manage/ApplicationScriptCardContainer';
import FertilityScriptCardContainer from 'manage/FertilityScriptCardContainer';
import PlantingScriptCardContainer from 'manage/PlantingScriptCardContainer';

const cardContainers = {
  [`${scriptTypes.FERTILITY}`]: FertilityScriptCardContainer,
  [`${scriptTypes.APPLICATION}`]: ApplicationScriptCardContainer,
  [`${scriptTypes.PLANTING}`]: PlantingScriptCardContainer
};

const ScriptList = ({
  areActiveFieldScriptsViewable,
  onSelectScript,
  productYear,
  scripts,
  scriptType
}) => {
  const hasPrescriptions = !!scripts.length;
  const classString = classNames({
    'vra-script-list': true,
    'vra-script-list--placeholder': !hasPrescriptions
  });
  const ScriptCardContainer = cardContainers[scriptType];

  let content = (
    <section className={classString} data-test-id={'script-list-empty'}>
      {productYear
        ? getMessage(`placeholder-text__script-list--${scriptType}`, { productYear })
        : getMessage('placeholder-text__prescriptions-list')}
    </section>
  );

  // are there any scripts?
  if (hasPrescriptions) {
    // do the scripts have zones so we can show full card info?
    if (areActiveFieldScriptsViewable) {
      const cards = scripts.map((script) => {
        return (
          <li key={`${script.id}-${scriptType}`}>
            <ScriptCardContainer
              onSelectScript={onSelectScript}
              script={script}
            />
          </li>
        );
      });

      content = (
        <FlipMove
          enterAnimation={null}
          leaveAnimation={null}
          typeName='ul'>
          {cards}
        </FlipMove>
      );
    } else {
      content = (
        <div className='vra-script-list__spinner-wrapper'>
          <Spinner size="24"/>
        </div>
      );
    }
  }
  return (
    <section
      className='vra-script-list__wrapper'
      data-test-id={`script-list-${scriptType}`}
    >
      {content}
    </section>
  );
};

ScriptList.propTypes = {
  areActiveFieldScriptsViewable: propTypes.bool,
  onSelectScript: propTypes.func,
  productYear: propTypes.string.isRequired,
  scriptType: propTypes.string,
  scripts: propTypes.array.isRequired
};
export default ScriptList;
